import { Trans } from '~/common/context';
import { ICustomer } from '~/common/types';
import { Card, Table, Title } from '@wyz/ui';

export default function ProximityStockTable({
  customer,
}: {
  customer: ICustomer;
}) {
  return (
    <Card>
      <Card.Header>
        <Title heading='lg' color='tertiary' weight='bold'>
          <Trans i18nKey='app.common.supplier.proximity_stocks' />
        </Title>
      </Card.Header>
      <Card.Body>
        <div className='bg-neutral-grey-1 border rounded-3 border-neutral-grey-4 p-3'>
          <Table>
            <thead>
              <tr className='fs-xs'>
                <th>
                  <Trans i18nKey='app.common.rank' />
                </th>
                <th>
                  <Trans i18nKey='app.entity.form.proximity_stocks_table.entity_code_header' />
                </th>
                <th>
                  <Trans i18nKey='app.entity.form.proximity_stocks_table.company_name_header' />
                </th>
                <th>
                  <Trans i18nKey='app.common.customer.city' />
                </th>
              </tr>
            </thead>
            <tbody className='text-title-color fw-semi-bold'>
              {customer.proximityStocks.map((proximityStock, index) => (
                <tr key={index}>
                  <td>{proximityStock.rank}</td>
                  <td>{proximityStock.customer.code}</td>
                  <td>
                    {proximityStock.alias.trim() === ''
                      ? proximityStock.customer.name
                      : proximityStock.alias}
                  </td>
                  <td>{proximityStock.customer.deliveryInformation.city}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
}
